/**
 * Picks v2 or v1 of the Author edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AuthorsAddEditPage   from './AuthorsAddEditPage';
import AuthorsAddEditPageV2 from './AuthorsAddEditPageV2';

export default function AuthorsAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AuthorsAddEditPageV2 : AuthorsAddEditPage;
  return <Component {...props} />;
}
